// 模板设置模块 接口集合
import request from '../request.js'

// 模板设置-分页查询模板 --- 李开明
export const getTemplates = function (data) {
    return request({
        url: 'operateProtocolTemplate/selectTemplatePage',
        method: 'post',
        data
    })
}

// 模板设置-设置模板启用或禁用 --- 李开明
export const setStatus = function (data) {
    return request({
        url: 'operateProtocolTemplate/setTemplateStatus',
        method: 'post',
        data
    })
}

// 模板设置-删除模板 --- 李开明
export const delTemplate = function (data) {
    return request({
        url: 'operateProtocolTemplate/deleteTemplate',
        method: 'post',
        data
    })
}

// 模板设置-新增或修改协议模板
export const saveTemplate = function (data) {
    return request({
        url: 'operateProtocolTemplate/saveOrUpdateTemplate',
        method: 'post',
        data
    })
}

// 模板设置-根据应用业务和应用类型查询模板字段列表
export const getFieldList = function (data) {
    return request({
        url: 'operateProtocolTemplate/getTemplateFieldByApplys',
        method: 'post',
        data
    })
}

// 模板设置-模板字段分页查询
export const getAllFields = function (data) {
    return request({
        url: 'operateTemplateField/selectTemplateFieldPage',
        method: 'post',
        data
    })
}

// 模板设置-模板字段新增或修改
export const saveFields = function (data) {
    return request({
        url: 'operateTemplateField/saveOrUdateTemplateField',
        method: 'post',
        data
    })
}

// 模板设置-模板字段删除
export const deleteFields = function (data) {
    return request({
        url: 'operateTemplateField/deleteTemplateFieldById',
        method: 'post',
        data
    })
}